import userWorkspaceService from '@/services/userWorkspace.service';
import config from '@/config/prod.env';

const actions = {    
    async getByWorkspaceIdAndUserIds({ dispatch }, obj) {
        return await userWorkspaceService.getByWorkspaceIdAndUserIds(obj.workspaceId, obj.userIds);
    },
    
    async createUserWorkspaceMultiple({ dispatch, commit }, obj) {
        let body = [];
        obj.userIds.forEach(userId => {
            body.push({
                workspaceId: obj.workspaceId, 
                userId: userId
            });
        });
        let res = await userWorkspaceService.createMultiple(body);
        if(res.isOk) {
            dispatch("alert/success", "Cập nhật dữ liệu thành công", { root: true });
        } else {
            dispatch("alert/error", config.DEFAULT_ERROR_MESSAGE, { root: true });
            return false;
        }
    },

    async deleteByWorkspaceIdAndUserIds({ dispatch }, obj) {
        return await userWorkspaceService.deleteByWorkspaceIdAndUserIds(obj.workspaceId, obj.userIds);
    },
};

export const userWorkspace = {
    namespaced: true,
    actions
};